
const verifyEnterpriseCollectorIsCorrect = (document: string, data: any[]): boolean => {
  return data.some(item => item.document === document);
}

export { verifyEnterpriseCollectorIsCorrect }
